export default class Keyword {

    id = null
    name = null
    default = null
    created_at = null
    updated_at = null

    constructor(data) {
        this.id = data?.id ?? this.id;
        this.name = data?.name ?? this.name;
        this.default = data?.default ?? this.default;
        this.created_at = data?.created_at ?? this.created_at;
        this.updated_at = data?.updated_at ?? this.updated_at;
        
        return this
    }
}